import Vue from "vue";


import { faCars } from "@fortawesome/pro-regular-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faCars);

Vue.component("font-awesome-icon", FontAwesomeIcon);

